import React from "react";
import { connect } from "react-redux";
import { Badge } from "antd";

import { selectActiveJobsForPatient } from "../../../../reducers/scrapeJobs";

/**
 * Pulsing placeholder shown at the top of the Breakdowns list while an AI
 * breakdown fetch is running for the selected policy — so the user sees a new
 * breakdown is on its way before it lands (previously the only sign was the
 * "AI Verification" button spinner). Reads the same ScrapeJobs slice that drives
 * that button. Renders null when nothing relevant is running.
 *
 * A running job counts when it belongs to this policy (or carries no policy id)
 * and isn't an eligibility/predetermination/estimate/payment run — i.e. it's a
 * breakdown/coverage fetch, which is what this modal's AI Verification triggers.
 */
function BreakdownInProgressRow({ jobs, policyId }) {
  const running = (jobs || []).some(function (j) {
    const op = (j.operation_type || "").toLowerCase();
    const isOtherOp =
      op.indexOf("eligib") >= 0 ||
      op.indexOf("predeterm") >= 0 ||
      op.indexOf("estimate") >= 0 ||
      op.indexOf("payment") >= 0;
    const matchesPolicy =
      policyId == null || j.policy_id == null || String(j.policy_id) === String(policyId);
    return !isOtherOp && matchesPolicy;
  });

  if (!running) return null;

  return (
    <div
      style={{
        margin: "12px 16px 4px",
        padding: "12px 14px",
        borderRadius: 8,
        background: "#f6f1fd",
        border: "1px dashed #c9b6ef",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <Badge status="processing" />
        <span style={{ fontWeight: 600, color: "#6B43B5" }}>New breakdown</span>
      </div>
      <div style={{ fontSize: 12, color: "rgba(0,0,0,0.55)", marginTop: 4 }}>
        Fetching from the carrier…
      </div>
    </div>
  );
}

const mapStateToProps = function (state, ownProps) {
  return { jobs: selectActiveJobsForPatient(state, ownProps.patientId) };
};

export default connect(mapStateToProps)(BreakdownInProgressRow);
